module.exports = __webpack_public_path__ + "img/swift-bostergreen-gls-azul-metalico.af586e85.png";